import { connect } from 'react-redux';
import Cms from '../components/Cms';
import { compose, lifecycle } from 'recompose';
import { createStructuredSelector } from 'reselect';
import { clientNameSelector } from 'store/modules/auth';
import {
  fetchCampaign,
  fetchEncodings,
  createEncoding,
  encodingsSelector,
  clearCms,
} from '../modules';

const mapStateToProps = createStructuredSelector({
  encodings: encodingsSelector,
  clientName: clientNameSelector,
});

const mapDispatchToProps = dispatch => ({
  fetchCampaign(id) {
    dispatch(fetchCampaign(id));
  },
  fetchEncodings(campaignId) {
    dispatch(fetchEncodings(campaignId));
  },
  createEncoding(campaignId, file) {
    dispatch(createEncoding(campaignId, file));
  },
  clearCms() {
    dispatch(clearCms());
  },
});

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  lifecycle({
    componentDidMount() {
      const { id } = this.props.match.params;
      this.props.fetchCampaign(id);
      this.props.fetchEncodings(id);

      this.props.history.push('/dashboard');
    },
    componentWillUnmount() {
      this.props.clearCms();
    },
  })
);

export default enhance(Cms);
